<template>
  <div class="card mb-4">
    <TableInfoBar
      :total="totalItems"
      v-model:pageSize="pageSize"
      :page-sizes="pageSizes"
      create-label="업무장소 등록"
      v-model:query="q"
      :searchPlaceholder="'장소명/URN/주소 검색'"
      @search="onSearch"
      @create="createData"
    />

    <div class="card-body px-4 pt-0 pb-2">
      <BaseDataTable
        :loading="loading"
        :items="bizLocationList"
        :columns="columns"
        :total="totalItems"
        v-model:page="page"
        v-model:pageSize="pageSize"
        :page-sizes="pageSizes"
        :colgroup="colgroup"
        :rowKey="rowKey"
        empty-message="등록된 업무장소가 없습니다."
        @row-click="onRowClick"
      >
        <template #row="{ item, index }">
          <td class="text-center text-sm">{{ totalItems - rowStartIndex - index }}</td>
          <td class="text-center text-sm">{{ item.name }}</td>
          <td class="text-center text-sm">
            <CustomBadge level="very-high" size="sm" :label="item.urn" />
          </td>
          <td class="text-sm">{{ item.address }}</td>
          <td class="text-center text-sm">{{ formatDate(item.createdAt) }}</td>
          <td class="text-center text-sm">{{ item.updatedAt ? formatDate(item.updatedAt) : '-' }}</td>
        </template>
      </BaseDataTable>
    </div>
  </div>

  <BizLocationTour />
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import TableInfoBar from '@/components/pagination/TableInfoBar.vue';
import SoftButton from "@/components/SoftButton.vue";
import BizLocationTour from "@/components/tour/BizLocationTour.vue";
import api from '@/api/api';

export default {
  name: "biz-location-table",
  components: {
    CustomBadge,
    SoftButton,
    BaseDataTable,
    TableInfoBar,
    BizLocationTour
  },
  data() {
    return {
      loading: false,
      bizLocationList: [],
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50],
      totalItems: 0,
      sort: 'createdAt',
      columns: [
        { label: 'No.' },
        { label: '장소명' },
        { label: 'urn' },
        { label: '주소' },
        { label: '생성일시' },
        { label: '수정일시' },
      ],
      colgroup: [
        'width:8%',
        'width:20%',
        'width:20%',
        'width:22%',
        'width:15%',
        'width:15%',
      ],
      q: "",
    };
  },
  computed: {
    rowStartIndex() {
      return (this.page - 1) * this.pageSize;
    },
  },
  watch: {
    page() {
      this.fetchData();
    },
    pageSize() {
      this.fetchData();
    },
  },
  mounted() { 
    const { page, size, q, sort } = this.$route.query;
    this.updatingFromRoute = true;  
    if (page) this.page = +page;
    if (size) this.pageSize = +size;
    if (q !== undefined) this.q = q;
    if (sort) this.sort = sort;
    this.updatingFromRoute = false;
    this.fetchData(); 
  },
  methods: {
    rowKey(item, idx) { return item.id ?? idx; },
    async fetchData() {
      if(this.loading) return;

      this.loading = true;
      try {
        const mfId = this.$store.getters['UserStore/getMfId'];
        const [res] = await Promise.all([
          api.get('/bizLocation/page', {
            params: { mfId, page: this.page, size: this.pageSize, sort: this.sort, query: this.q }
          }),
          new Promise(r => setTimeout(r, 600))
        ]);

        const r = res.data?.result || {};
        this.bizLocationList = r.items || [];
        this.totalItems = Number(r.total || 0);

        const pageCount = Math.max(1, Math.ceil(this.totalItems / this.pageSize));
        if (this.page > pageCount) this.page = pageCount;
      } catch (error) {
        console.error("업무장소 정보 불러오기 실패:", error);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.page = 1;
      this.fetchData();
    },
    onRowClick(item, index){
      this.$router.push({
        name: "BizLocationEdit",
        params: { id: item.id },
        query: {
          page: this.page,
          size: this.pageSize,
          q: this.q,
          sort: this.sort,
        },
      });
    },
    createData(){
      this.$router.push({
        name: "BizLocationCreate",
      });
    },
  }
};
</script>
